import styles from "./work_pilars.module.css";
import {FcAdvertising, FcBullish, FcDepartment, FcMindMap, FcVoicePresentation} from 'react-icons/fc';
import { FcCandleSticks } from "react-icons/fc";
import { Button, ButtonType } from "@/components/button";

interface WorkPilarItemProps {
  title: string;
  description: string;
  icon: any;
}

export const WorkPilarItem = (props: WorkPilarItemProps) => {
  const { title, description, icon } = props;

  return (
    <div className={styles.work_pilar_item}>
      <div className={styles.work_pilar_item__image}>
        {/* <Animation animation={animation} /> */}
        {icon}
      </div>
      <h3 className={styles.work_pilar_item__title}>{title}</h3>
      <div className={styles.work_pilar_item__description}>{description}</div>
    </div>
  );
};

export const WorkPilars = () => {
  return (
    <div className={styles.work_pilars}>
      <h2 className={styles.work_pilars_title}>¿Que podemos hacer por ti?</h2>
      <div className={styles.work_pilars__items}>
        <WorkPilarItem
          title={"Inversiones en un solo lugar"}
          description={
            "Administra tus inversiones en trading e inmuebles desde un solo panel de control intuitivo"
          }
          icon={<FcMindMap />}
        />
        <WorkPilarItem
          title={"Inversión en cripto y acciones"}
          description={"Desarrolla estrategias de inversión en criptomonedas y acciones y sigue su evolución en tiempo real."}
          icon={<FcCandleSticks />}
        />
        <WorkPilarItem
          title={"Inversión inmobiliaria"}
          description={"Gestiona tus propiedades y realiza las gestiones desde la plataforma."}
          icon={<FcDepartment />}
        />
        <WorkPilarItem
          title={"Alertas y Oportunidades"}
          description={
            "Recibe notificaciones en tiempo real sobre oportunidades de compra y venta."
          }
          icon={<FcAdvertising />}
        />
        <WorkPilarItem
          title={"Optimización de Portafolio"}
          description={"Mejora el rendimiento de tu cartera con análisis y estrategias respaldadas por datos."}
          icon={<FcBullish />}
        />
        
        <WorkPilarItem
          title={"Asesoramiento y consultoría"}
          description={"Asesoramiento personalizado para ayudarte a tomar las mejores decisiones en tus inversiones."}
          icon={<FcVoicePresentation />}
        />
      </div>
      <div className={styles.button_container}>
        <Button 
          label="Accede a nuestra plataforma [BETA]"
          href="https://app.keperin.com/"
          type={ButtonType.SECONDARY}
          className={styles.button}
        />
      </div>
    </div>
  );
};
